import router from "../router/index";

function goPage(param) {
    router.push(param);
}

export default {
    goPage,
};
